exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-responsive {\n  position: relative;\n  overflow: hidden;\n  flex: 1 0 auto;\n  max-width: 100%;\n  display: flex;\n}\n.v-responsive__content {\n  flex: 1 0 0px;\n  max-width: 100%;\n}\n.v-application--is-ltr .v-responsive__sizer ~ .v-responsive__content {\n  margin-left: -100%;\n}\n.v-application--is-rtl .v-responsive__sizer ~ .v-responsive__content {\n  margin-right: -100%;\n}\n.v-responsive__sizer {\n  transition: padding-bottom 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);\n  flex: 1 0 0px;\n}", ""]);

// exports
